import { ZitadelServiceUser, ZitadelUser } from "@src/types/user-management";

type UserDrawerInputField =
  | "username"
  | "given_name"
  | "family_name"
  | "email"
  | "name"
  | "description";

export const trimUserInputs = (
  user: Partial<ZitadelUser | ZitadelServiceUser> | null,
): Partial<ZitadelUser | ZitadelServiceUser> | null => {
  if (!user) return null;

  const fieldsToTrim: UserDrawerInputField[] =
    user.type === "HUMAN"
      ? ["username", "given_name", "family_name", "email"]
      : ["username", "name", "description"];

  const cleanedUser: Partial<ZitadelUser | ZitadelServiceUser> = { ...user };

  fieldsToTrim.forEach((field) => {
    const value = cleanedUser[field];
    if (typeof value === "string") {
      cleanedUser[field] = value.trim();
    }
  });

  return cleanedUser;
};
